import { defineStore } from 'pinia'
import { reactive } from 'vue'

const DEFAULT_TIMEOUT = 4000

export const useSnackbarStore = defineStore('snackbar', () => {
  const message = reactive({
    show: false,
    text: '',
    color: 'info',
    actionRoute: null,
    actionText: null,
    location: 'bottom'
  })

  let timeoutId = null

  function dismiss() {
    message.show = false
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  function show(text, color = 'info', options = {}) {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
    message.text = text
    message.color = color
    message.actionRoute = options.actionRoute ?? null
    message.actionText = options.actionText ?? null
    message.location = options.location ?? 'bottom'
    message.show = true
    const timeout = options.timeout ?? DEFAULT_TIMEOUT
    if (timeout > 0) {
      timeoutId = setTimeout(() => {
        message.show = false
        timeoutId = null
      }, timeout)
    }
  }

  function success(text, options = {}) {
    show(text, 'success', options)
  }

  function error(text, options = {}) {
    show(text, 'error', options)
  }

  function warning(text, options = {}) {
    show(text, 'warning', options)
  }

  function info(text, options = {}) {
    show(text, 'info', options)
  }

  return {
    message,
    show,
    success,
    error,
    warning,
    info,
    dismiss
  }
})
